import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for T5M2 (公告核准沖銷)
// ============================================================

export interface ReverseCandidate {
  ft120_01: string;       // 申請單號
  ft120_11: string;       // 公告開始日 (YYYY-MM-DD)
  ft120_12: string;       // 公告結束日 (YYYY-MM-DD)
  ft120_13: string;       // 申請人員工代碼
  ft120_14: string;       // 申請部門代碼
  ft120_15: string;       // 申請日期 (YYYY-MM-DD)
  ft120_21: string;       // 公告主題
  applicant_name: string; // 申請人姓名 (F901 lookup)
  dept_name: string;      // 部門名稱 (F106 lookup)
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const t5m2Api = {
  /** Query announcement candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/t5m2/candidates', { params });
    return res.data;
  },

  /** Execute batch approval reversal for selected announcements */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/t5m2/reverse', { items });
    return res.data;
  },
};
